const textCollator = new Intl.Collator(undefined, { sensitivity: "accent", numeric: false });

export const ORDER_SOURCE_LABELS = {
  direct_site: "Direct Site", client_portal: "Client Portal", wholesale: "Wholesale", admin: "Admin",
};

export function orderSource(order) {
  if (order.source === "client_portal") return "client_portal";
  if (order.source === "direct_site") return "direct_site";
  if (order.payment_source === "stripe-cart") return "direct_site";
  if (order.type === "wholesale") return "wholesale";
  return "admin";
}

export const orderItemsText = (order) => (order.items || order.products || [])
  .map((item) => `${item.name}×${item.qty}`).join(", ");

export function orderPartnerText(order, client, partnersById) {
  return order.fulfilled_by_name || (order.assignment === "warehouse"
    ? "Warehouse (Default)" : partnersById.get(client?.endpoint_partner_id)?.name || "—");
}

function textValue(value) {
  if (value == null) return null;
  const text = String(value).trim();
  return text && text !== "—" ? text : null;
}

export function orderSortValue(order, key, clientsById, partnersById) {
  if (key === "created_at") {
    const date = textValue(order.created_at);
    const time = date == null ? NaN : Date.parse(date);
    return Number.isFinite(time) ? time : null;
  }
  if (key === "revenue") {
    const amount = textValue(order.total);
    const value = amount == null ? NaN : Number(amount);
    return Number.isFinite(value) ? value : null;
  }
  if (key === "client") return textValue(order.client_name);
  if (key === "source") return ORDER_SOURCE_LABELS[orderSource(order)];
  if (key === "items") return textValue(orderItemsText(order));
  if (key === "status") return textValue(order.status);
  if (key === "partner") return textValue(orderPartnerText(order, clientsById.get(order.client_id), partnersById));
  return null;
}

export function sortOrders(orders, key, direction, clientsById = new Map(), partnersById = new Map()) {
  // No selection: retain the server's existing default order exactly.
  if (!key) return orders;
  const sign = direction === "desc" ? -1 : 1;
  return orders.map((order, index) => ({ order, index, value: orderSortValue(order, key, clientsById, partnersById) }))
    .sort((a, b) => {
      // Null placement and stable ties never reverse with the sort direction.
      if (a.value == null || b.value == null) {
        if (a.value == null && b.value == null) return a.index - b.index;
        return a.value == null ? 1 : -1;
      }
      const comparison = typeof a.value === "number"
        ? a.value - b.value : textCollator.compare(a.value, b.value);
      return comparison === 0 ? a.index - b.index : sign * comparison;
    })
    .map(({ order }) => order);
}